// sandbox
export const sandboxConfig = {
    synswiBaseUrl: "https://api-sandbox.synswi.com",
}

// development
export const devConfig = {
    synswiBaseUrl: "https://api-dev.synswi.com",
}

// production
export const prodConfig = {
    synswiBaseUrl: "https://api.synswi.com"
}

const env = import.meta.env.VITE_ENV
console.log('env', env)
export const config = env === 'prod' ? prodConfig : env === 'sandbox' ? sandboxConfig : devConfig

